var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionInfoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-60.000000, -1373.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Info/Small",
    transform: "translate(60.000000, 1373.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,10.4873846 C14.3384615,10.4873846 12.992,9.14092308 12.992,7.47938462 C12.992,5.81907692 14.3384615,4.47138462 16,4.47138462 C17.6615385,4.47138462 19.008,5.81907692 19.008,7.47938462 C19.008,9.14092308 17.6615385,10.4873846 16,10.4873846 L16,10.4873846 Z M18.4787692,22.7483077 C18.4787692,25.2553846 17.6590769,27.5298462 13.5556923,27.5298462 L13.5556923,14.1796923 L18.4787692,14.1796923 L18.4787692,22.7483077 Z M16,0 C7.16307692,0 0,7.16430769 0,16 C0,24.8369231 7.16307692,32 16,32 C24.8369231,32 32,24.8369231 32,16 C32,7.16430769 24.8369231,0 16,0 L16,0 Z",
    id: 253
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionInfoSmall);
export default __webpack_public_path__ + "static/media/navigation-and-action-info-small.b4a8873b.svg";
export { ForwardRef as ReactComponent };